import type { AnyNode, ObjectForm } from "@pdfking/forms"
import type { CustomConfig, FilesSchema } from "@pdfking/imposition-form"
import { FilesForm } from "@pdfking/imposition-form"
import { WaitPromises } from "@pdfking/tfunc"

import type { Preset } from "./Preset"

export type ResolvedPreset = {
  preset: Preset
  form: AnyNode
  // The uploaded-file rows' form. Not the preset's — it is the same for every
  // imposition kind — it just travels with it so a host builds both nodes at
  // once, from the same raw data.
  files_form: ObjectForm<FilesSchema>
}

const PRESET_ID = "file"

// Resolve raw imposition data to its preset and forms. The preset is picked out
// of the host's `presets` (`PresetList`, or its own built on it) from
// `data["preset"]` (default the file pass-through). The form offers the
// preset's markings and materials.
export const ResolvePreset = async (
  data: Record<string, unknown>,
  config: CustomConfig,
  presets: Record<string, Preset>
): Promise<ResolvedPreset> => {
  const preset = presets[data["preset"] as string] || presets[PRESET_ID]!

  const [form, files_form] = await WaitPromises([
    preset.build_form({
      ...config,
      material_list: preset.material_list,
      hooks_list: preset.hooks_list,
    }),
    FilesForm(config),
  ])

  return { preset, form, files_form }
}
